import { configureStore, combineReducers } from '@reduxjs/toolkit';
import auth from './slices/authSlice';
//import mainLayout from './slices/mainLayoutSlice'
import readers from './slices/readerSlice';
import readerReports from './slices/readerReportSlice';
import maps from './slices/mapSlice';
import facilities from './slices/facilitySlice';
import scanSession from './slices/scanSessionSlice';
import geofences from './slices/geofenceSlice';
import settings from './slices/settingsSlice';
import userScopes from './slices/userScopeSlice';
import tasksQueue from './slices/tasksQueueSlice';

const rootReducer = combineReducers({
  auth,
  // mainLayout,
  maps,
  readers,
  readerReports,
  facilities,
  scanSession,
  geofences,
  settings,
  userScopes,
  tasksQueue,
});

const defaultMiddlewareConfig = {
  serializableCheck: {
    // Ignore these action types
    // ignoredActions: ['maps/updateTargetLocationState'],
    // Ignore these field paths in all actions
    // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
    // Ignore these paths in the state
    // ignoredPaths: ['items.dates'],
  },
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(defaultMiddlewareConfig),
});

//Type of root state & dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
